import React from "react";
import Article from "../sections/BlogTemplate/Article";
import Relatedblogs from "../sections/BlogTemplate/Relatedblogs";
import { publicMainHeaderOffsetClass } from "../sections/Public/shared/publicLayoutSpec";

const BlogTemplate = () => {
  return (
    <div
      className={`tp-container-main mx-auto ${publicMainHeaderOffsetClass()}`}
    >
      <Article />
      <Relatedblogs />
    </div>
  );
};

export default BlogTemplate;
